import th_TH from '../../date-picker/locale/th_TH';
export default th_TH;



// WEBPACK FOOTER //
// ./components/calendar/locale/th_TH.tsx